import React from 'react';
import { Popover, Button } from 'antd';
import { PlusOutlined, FolderAddOutlined, FileAddOutlined } from '@ant-design/icons';
import { useLanguage } from '../../contexts/LanguageContext';
import styles from './EntryPopover.module.scss';

interface EntryPopoverProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onCreateFolder: () => void;
  onCreateFile: () => void;
  userRole?: string;
}

const EntryPopover: React.FC<EntryPopoverProps> = ({
  isOpen,
  onOpenChange,
  onCreateFolder,
  onCreateFile,
  userRole
}) => {
  const { t } = useLanguage();

  const entryPopoverContent = (
    <div className={styles.popoverContent}>
      {/* Create Folder - Sadece Admin, SuperAdmin ve AccountOwner için */}
      {(userRole === 'AccountManager' || userRole === 'SuperAdmin' || userRole === 'AccountOwner') && (
        <a 
          className={styles.popoverItem} 
          href="#" 
          onClick={e => { 
            e.preventDefault(); 
            onCreateFolder(); 
            onOpenChange(false); 
          }}
        >
          <FolderAddOutlined /> <span>{t('projectDetail.createFolder')}</span>
        </a>
      )}
      {/* Create File - Tüm yetkili roller için */}
      <a 
        className={styles.popoverItem} 
        href="#" 
        onClick={e => { 
          e.preventDefault(); 
          onCreateFile(); 
          onOpenChange(false); 
        }}
      >
        <FileAddOutlined /> <span>{t('projectDetail.createFile')}</span>
      </a>
    </div>
  );

  // Admin, SuperAdmin, AccountOwner, AgencyAccountViewer ve BrandAccountViewer için göster
  if (!['AccountManager', 'SuperAdmin', 'AccountOwner', 'InternalTeam', 'BrandAccountViewer'].includes(userRole || '')) {
    return null;
  }

  return (
    <Popover 
      content={entryPopoverContent} 
      trigger="click" 
      open={isOpen} 
      onOpenChange={onOpenChange} 
      placement="bottomRight"
    >
      <Button icon={<PlusOutlined />} onClick={() => onOpenChange(true)}>
        {t('projectDetail.newEntry')}
      </Button>
    </Popover>
  );
};

export default EntryPopover; 